        (function() {
            'use strict';

            var AttributeTagCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, $sce,$filter) {

            //     console.log("Inside AttributeTagCtrl");

            //     $scope.tagModel = {};
            //     $scope.attributeTagList = {};
            //     $scope.tagModel.createInner = true;
            //     $scope.tagModel.errorMessage = false;


            //     $scope.orgAttributeTagList = $scope.tagModel.orgAttributeTagListJson;


            //     $scope.findOrgAttributeTagList = function() {
            //     $scope.selectedOrgId = $scope.tagModel.source
            //     $scope.orgAttributeTagList = $scope.tagModel.orgAttributeTagListJson;
            //     $scope.attributeTagListTemp = $filter('filter')($scope.orgAttributeTagList, { orgId: $scope.selectedOrgId });
            //     $scope.attributeTagList = $scope.attributeTagListTemp[0].tagTypeList;
            //     $scope.tagModel.createInner = true;

            //     };

            //     $scope.checkInner = function(){
            //         if($scope.tagModel.tagType!=undefined){
            //             $scope.tagModel.createInner=false
            //             $scope.tagModel.editInner = false;
            //         }

            //      };


            //     var ajaxCallList = function(ajaxUrl, data) {
            //     var errorMsg = 'Error';
            //     ajaxCall.getData(ajaxUrl, data).then(
            //         function(result) {
            //              console.log("result.data" + result.data);
            //               $scope.closePop();

            //         },
            //         function(result) {

            //         }
            //     );
            // }



            // $scope.submit = function($event){
            //   //   $scope.name = modalVal;
            //      console.log("Values passed :");
            //      console.log($scope.tagModel);
            //      var jsonDateFrom = $scope.tagModel.tagFromDate;
            //      $scope.tagModel.tagFromDate_display = $filter('date')(new Date(jsonDateFrom),"yyyy-MM-dd HH:mm:ss");
            // //     $scope.tagModel.tagToDate_display = $filter('date')(new Date($scope.tagModel.tagToDate),"yyyy-MM-dd HH:mm:ss");

            //      var ajaxUrl = WEBAPP_PATH + "/TagAttributeDisplay/save";
            //      ajaxCallList(ajaxUrl , $scope.tagModel);
            //   //   $uibModalInstance.close($scope.tagModel);
            // }


            //    $scope.closePop = function($event) {
            //     $uibModalInstance.close($scope.tagModel);

            // }


             }
            AttributeTagCtrl.$inject = ['$scope', '$compile', '$uibModalInstance','ajaxCall', '$sce','$filter'];
            angular.module('app').controller('AttributeTagCtrl', AttributeTagCtrl);

        }());